import React from 'react';
import { Icon } from 'semantic-ui-react';
import './Landing.css';

const StatCard = ({ icon, label, value }) => {
  return (
    <div className="stat-card">
      <div className="stat-icon">
        <Icon name={icon} size="big" />
      </div>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
    </div>
  );
};

export default StatCard;
